export function cleanUrl(u?: string | null): string {
  if (!u) return '';
  return u.replace(/&amp;/g, '&').trim();
}

const CDN_HOST_RE = /(fbcdn|cdninstagram|tiktokcdn|tiktokcdn-(?:us|eu)|akamaized)\./i;
export function proxify(u?: string | null): string {
  const url = cleanUrl(u);
  if (!url) return '';
  try {
    const host = new URL(url).hostname.toLowerCase();
    return CDN_HOST_RE.test(host) ? `/img?url=${encodeURIComponent(url)}` : url;
  } catch {
    return url;
  }
}
